export class CorpAPWorkQueueEmailActionParameterDto {
    workQueueId: string;
    userId: string;
    emailJobId: string;
}
